/**
 * Générateur — Produire une formule littérale représentant la dépendance de
 * deux grandeurs.
 * Attendu ID : 175 | Niveau : 4ème | Domaine : Fonctions (O12)
 *
 * Doc prof (TANOED EXERCISEUR OGD/FONCTIONS 4E, Créé n°11 « L'abonnement de la
 * piscine ») : deux tarifs, sans abonnement (proportionnel w × n) et avec
 * abonnement (affine F + v × n). Plan de cartes validé en juillet 2026
 * (historique) : une carte « Écrire la formule des deux tarifs » à cinq
 * formats, formule_simple_qcm, formule_abo_qcm, formule_prop_qcm,
 * formule_calcul_texte_trou_saisie, formule_relier.
 * Invariant gardé : arithmétique décimale EXACTE en dixièmes d'euro (aucun
 * flottant, tirerTarif de fonctions.js, partagé avec 176).
 *
 * Revue 2026-09-23 (vague 3), décisions du coordinateur appliquées en mode
 * auto. Attendu de fin de 4e (Eduscol, attendus de fin d'année, p. 6) : « Il
 * produit une formule littérale représentant la dépendance de deux
 * grandeurs. » Exemple de réussite : « On enlève quatre carrés superposables
 * aux quatre coins d'un rectangle de 20 cm de longueur et 13 cm de largeur.
 * On s'intéresse à l'aire de la figure restante (en blanc). En prenant comme
 * variable le côté d'un carré, exprime l'aire de la figure restante. »
 * (260 − 4x²), figure sans cote ni lettre. Cours (19Eq4e, carte de cinéma) :
 * « Exprimer en fonction de x le prix à payer … en comptant l'abonnement » :
 * 8x + 20. Le pas de 4e : une formule à deux termes, ou avec un carré et une
 * soustraction ; la formule à une seule opération (k × n) est de 5e.
 *   - « QCM tarif simple » (formule_simple_qcm) SORTI : la formule k × n est
 *     celle de 5e (gen 994), et la clé était l'option la plus proche des trois
 *     autres dans 100 % des tirages.
 *   - « QCM proportionnalité » (formule_prop_qcm) SORTI : reconnaître une
 *     situation de proportionnalité est l'attendu 171 ; la clé était toujours
 *     « Le tarif sans abonnement » et la consigne « Une seule » éliminait deux
 *     options sur quatre.
 *   - « Saisie trous » (formule_calcul_texte_trou_saisie) SORTIE : la consigne
 *     DONNAIT les deux formules, l'élève ne faisait que substituer (geste de 5e,
 *     « tableau de valeurs à partir d'une formule », déjà servi par 176).
 *   - Carte des tarifs renommée « Écrire la formule d'un tarif » ; elle garde
 *     le QCM de l'abonnement et le relier.
 *   - QCM de l'abonnement (formule_abo_qcm) : grille prix unitaire ×
 *     parenthèses, clé F + v × n, mauvais_prix F + w × n, parenthesage
 *     (F + v) × n, les_deux (F + w) × n ; la clé était l'option la plus proche
 *     des trois autres dans 50,4 % des tirages ; le candidat v + F × n, jamais
 *     servi et de même valeur que F × n + v, est retiré. « une part fixe de
 *     30 € » en phrase (plus de parenthèse) ; la lettre n et les quatre
 *     formules en KaTeX, décimaux en {,}.
 *   - Relier (formule_relier) RECOMPOSÉ : trois situations de structures
 *     différentes qui portent LES MÊMES deux nombres a et b (« chaque entrée
 *     coûte a € » ; « une carte à b €, puis a € l'entrée » ; « une carte à a €,
 *     puis b € l'entrée ») vers a × n, b + a × n, a + b × n, plus deux leurres
 *     nommés, parenthesage (a + b) × n et somme_pour_produit a + b + n ; « Deux
 *     formules sont en trop. » Avant : trois tarifs proportionnels dont chaque
 *     formule recopiait le nombre de sa source (100 %), aucun leurre. Mode
 *     auto, À ARBITRER : chaque leurre est écrit dans l'ordre des nombres d'une
 *     des deux situations à carte, tirée au hasard ((b + a) × n et a + b + n, ou
 *     (a + b) × n et b + a + n, mêmes valeurs) ; écrits tous deux dans l'ordre
 *     (a, b), la situation « carte à b €, puis a € » se reliait en recopiant ses
 *     nombres dans l'ordre dans 100 % des tirages.
 *   - NOUVELLE carte « Exprimer l'aire restante », l'exemple de réussite : la
 *     figure du plafond (rectangle, quatre carrés gris aux coins, figure
 *     restante en blanc, ni cote ni lettre, attribut alt), longueur L de 10 à
 *     30 cm et largeur l de L/2 à L − 1 dans le texte (le couple (20 ; 13)
 *     d'Eduscol exclu, sacrifié), « On note x le côté d'un carré ».
 *     QCM (aire_qcm_unique) : clé L·l − 4x², écrite avec la valeur de L·l ;
 *     carre_oublie L·l − 4x, un_seul_carre L·l − x², rectangle_interieur
 *     (L − 2x)(l − 2x), deux à deux différentes (relu : trois valeurs de x).
 *     Mode auto, À ARBITRER : un cinquième choix, les_deux L·l − x (un seul
 *     carré, et son aire prise pour son côté), complète la grille { 4 carrés,
 *     1 carré } × { x², x } ; avec les quatre choix décidés, la clé était
 *     l'option la plus proche des trois autres dans 100 % des tirages (elle
 *     cumule le 4 et le x² que chaque distracteur n'a qu'à moitié), avec la
 *     grille complète dans 0 %.
 *     Saisie (aire_texte), mode auto, À ARBITRER : « Exprime l'aire de la
 *     figure restante en fonction de x. », comparaison d'expression, écritures
 *     admises = ecrituresPolynome (ordres des termes, + de tête, 4*x²) PLUS,
 *     mode auto, À ARBITRER, l'aire du rectangle laissée en produit (20*13,
 *     13*20) et le carré écrit 4*x*x : une réponse juste n'est jamais refusée.
 *   - Rappel brouillon : AUCUN (décision : produire une formule se fait de
 *     tête, rien n'est à calculer).
 *   - Second chemin : toute formule affichée (options, cibles, leurres) est
 *     RELUE dans son écriture LaTeX par un petit lecteur exact (rationnels)
 *     et comparée au prix raconté par l'histoire, ou à l'aire calculée par
 *     morceaux ((L − 2x) × l + 2 × x × (l − 2x)) ; throw si la clé ne colle
 *     pas, nouveau tirage si deux formules coïncident. Aucun solveur test-side
 *     ne couvre 175 (solvers/index.js ne route pas cet attendu) ; le test
 *     jetable tmp-revue-175 relit le texte rendu.
 *   - Contrat des distracteurs exporté (REGLES_DISTRACTEURS_QCM), codes dans
 *     _meta.params.distracteurs.
 * Deux cartes, quatre formats (cinq avant), dont deux QCM.
 */

import {
    randInt, randomChoice, randomChoiceMultiple, shuffle,
    makeQcm, makeSaisie, makeRelier, tex, ecrituresPolynome,
} from '../../../utils';
import { fmtT, tirerTarif, auLieu } from './fonctions';

const ATTENDU_ID = 175;
const L_TARIF = 'Écrire la formule d’un tarif';
const L_AIRE = 'Exprimer l’aire restante';
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// ═════════ Lecture exacte d'une formule affichée (second chemin) ═════════
// Rationnels { p, q } ; le lecteur comprend ce que les cartes écrivent :
// entiers et décimaux en {,}, +, -, \times, parenthèses, une lettre (n ou x),
// l'exposant ^2, le produit implicite (4x, (L - 2x)(l - 2x)).

const pgcd = (a, b) => (b ? pgcd(b, a % b) : a);
const Q = (p, q = 1) => {
    const s = q < 0 ? -1 : 1;
    const g = pgcd(Math.abs(p), Math.abs(q)) || 1;
    return { p: (s * p) / g, q: (s * q) / g };
};
const qAdd = (a, b) => Q(a.p * b.q + b.p * a.q, a.q * b.q);
const qSub = (a, b) => Q(a.p * b.q - b.p * a.q, a.q * b.q);
const qMul = (a, b) => Q(a.p * b.p, a.q * b.q);
const qEgal = (a, b) => a.p === b.p && a.q === b.q;

/** Valeur exacte d'une écriture LaTeX de carte pour des valeurs des lettres ({ n: Q(3) }). */
const lireFormule = (latex, lettres) => {
    const src = String(latex).replace(/\\times/g, '×').replace(/\{,\}/g, ',').replace(/\s+/g, '');
    let i = 0;
    const erreur = () => new Error(`gen_175 : formule illisible « ${latex} » (position ${i})`);
    const nombre = () => {
        const m = /^\d+(,\d+)?/.exec(src.slice(i));
        if (!m) return null;
        i += m[0].length;
        const [e, d = ''] = m[0].split(',');
        return Q(Number(e + d), 10 ** d.length);
    };
    let expr;
    const primaire = () => {
        if (src[i] === '(') {
            i += 1;
            const v = expr();
            if (src[i] !== ')') throw erreur();
            i += 1;
            return v;
        }
        const nb = nombre();
        if (nb) return nb;
        if (/[a-z]/.test(src[i] || '') && lettres[src[i]]) {
            const v = lettres[src[i]];
            i += 1;
            return v;
        }
        throw erreur();
    };
    const facteur = () => {
        const v = primaire();
        if (src[i] !== '^') return v;
        i += 1;
        const e = nombre();
        if (!e || e.q !== 1) throw erreur();
        let r = Q(1);
        for (let k = 0; k < e.p; k++) r = qMul(r, v);
        return r;
    };
    const terme = () => {
        let v = facteur();
        for (;;) {
            if (src[i] === '×') { i += 1; v = qMul(v, facteur()); } else if (src[i] === '(' || /[a-z0-9]/.test(src[i] || '')) {
                v = qMul(v, facteur());                       // produit implicite
            } else return v;
        }
    };
    expr = () => {
        let v;
        if (src[i] === '-') { i += 1; v = qSub(Q(0), terme()); } else v = terme();
        while (src[i] === '+' || src[i] === '-') {
            const op = src[i];
            i += 1;
            const w = terme();
            v = op === '+' ? qAdd(v, w) : qSub(v, w);
        }
        return v;
    };
    const v = expr();
    if (i !== src.length) throw erreur();
    return v;
};

/** Les valeurs d'une formule en n (ou x) = 1, 2, 3 : deux formules de degré ≤ 2 sont égales ssi ces trois valeurs le sont. */
const empreinte = (latex, lettre) => [1, 2, 3].map((k) => lireFormule(latex, { [lettre]: Q(k) }));
const memesValeurs = (a, b) => a.every((v, k) => qEgal(v, b[k]));
/** Vrai si les formules sont deux à deux différentes (en tant que fonctions de la lettre). */
const deuxADeuxDifferentes = (latexs, lettre) => {
    const e = latexs.map((l) => empreinte(l, lettre));
    return e.every((a, i) => e.every((b, j) => i >= j || !memesValeurs(a, b)));
};

// ═════════ Carte 1 — Écrire la formule d'un tarif ═════════

/** Dixièmes d'euro → écriture KaTeX (virgule décimale protégée). */
const texT = (t10) => fmtT(t10).replace(',', '{,}');

const consigneTarifs = (t) => {
    const c = t.ctx;
    return `<p>${auLieu(c.lieu, true)}, on peut payer de deux façons pour ${tex('n')} ${c.actPl} :</p>`
        + '<ul style="margin:6px 0 6px 18px">'
        + `<li><b>Sans abonnement</b> : ${c.simple} à ${fmtT(t.w10)} €.</li>`
        + `<li><b>Avec ${c.abo}</b> : une part fixe de ${fmtT(t.F10)} €, puis ${fmtT(t.v10)} € par ${c.act}.</li>`
        + '</ul>';
};

// ─── QCM : la formule du tarif avec abonnement ────────────────
// Grille de deux erreurs croisées : le prix par entrée (v, ou w le prix sans
// abonnement) × les parenthèses (la part fixe payée une fois, ou à chaque
// entrée). Quatre cases, la clé et trois erreurs nommées.
const genFormuleAboQcm = () => {
    const t = tirerTarif();
    const { F10: F, v10: v, w10: w } = t;
    const options = [
        { latex: `${texT(F)} + ${texT(v)} \\times n`, code: null },
        { latex: `${texT(F)} + ${texT(w)} \\times n`, code: 'mauvais_prix' },
        { latex: `(${texT(F)} + ${texT(v)}) \\times n`, code: 'parenthesage' },
        { latex: `(${texT(F)} + ${texT(w)}) \\times n`, code: 'les_deux' },
    ];
    // Second chemin : la clé relue redonne le prix avec abonnement de l'histoire
    // pour n = 1 à 12 ; les quatre formules sont deux à deux différentes.
    for (let n = 1; n <= 12; n++) {
        if (!qEgal(lireFormule(options[0].latex, { n: Q(n) }), Q(t.prixAbo(n), 10))) {
            throw new Error(`gen_175 : clé ${options[0].latex} fausse pour n = ${n}`);
        }
    }
    if (!deuxADeuxDifferentes(options.map((o) => o.latex), 'n')) {
        throw new Error(`gen_175 : deux formules égales (${options.map((o) => o.latex).join(' ; ')})`);
    }
    const choix = options.map((o) => tex(o.latex));
    const payload = makeQcm(choix, choix[0],
        `${consigneTarifs(t)}<p><b>Quelle formule donne le prix payé, en euros, pour ${tex('n')} ${t.ctx.actPl} avec ${t.ctx.abo} ?</b></p>`,
        opts(L_TARIF));
    payload._meta.params = {
        w: fmtT(w), v: fmtT(v), F: fmtT(F), n0: t.n0,
        distracteurs: options.slice(1).map((o) => o.code),
    };
    return payload;
};

// ─── Relier : trois situations, les mêmes deux nombres ────────
// « chaque entrée coûte a € » → a × n ; « une carte à b €, puis a € l'entrée »
// → b + a × n ; « une carte à a €, puis b € l'entrée » → a + b × n. Les
// leurres : parenthesage (a + b) × n, somme_pour_produit a + b + n (a, b ≥ 3 :
// jamais égal à une cible). Chaque leurre est écrit dans l'ordre des nombres
// de L'UNE des deux situations « à une carte » (tirée au hasard), l'autre
// leurre dans l'ordre de l'autre : (b + a) × n et a + b + n, ou (a + b) × n et
// b + a + n, mêmes valeurs. Écrits tous deux dans l'ordre (a, b), les deux
// leurres ne ressemblaient qu'à la troisième situation, et la deuxième se
// reliait en recopiant ses nombres dans l'ordre (100 % des tirages).

const LIEUX_RELIER = ['la piscine', 'le cinéma', 'la patinoire', 'le parc aquatique', 'la salle d’escalade', 'le musée'];

const CONSIGNE_RELIER = `<p><b>Relie chaque situation à la formule du prix payé, en euros, pour ${tex('n')} entrées.</b> Deux formules sont en trop.</p>`;

/** Les trois situations et les deux leurres pour a, b et trois lieux, contrôlés ; null si deux formules coïncident. */
const composerRelier = (a, b, lieux, parenthesageSurLaDeuxieme) => {
    const situations = [
        { source: `${auLieu(lieux[0], true)}, chaque entrée coûte ${a} €.`, carte: 0, entree: a, latex: `${a} \\times n` },
        { source: `${auLieu(lieux[1], true)}, une carte coûte ${b} €, puis chaque entrée coûte ${a} €.`, carte: b, entree: a, latex: `${b} + ${a} \\times n` },
        { source: `${auLieu(lieux[2], true)}, une carte coûte ${a} €, puis chaque entrée coûte ${b} €.`, carte: a, entree: b, latex: `${a} + ${b} \\times n` },
    ];
    const [p, q] = parenthesageSurLaDeuxieme ? [b, a] : [a, b];
    const leurres = [
        { latex: `(${p} + ${q}) \\times n`, code: 'parenthesage' },
        { latex: `${q} + ${p} + n`, code: 'somme_pour_produit' },
    ];
    // Second chemin : chaque cible relue redonne le prix de SA situation
    // (carte + entrée × n) pour n = 0 à 12, et d'aucune autre ; aucun leurre ne
    // redonne le prix d'une situation.
    const prix = (s, n) => Q(s.carte + s.entree * n);
    const colle = (latex, s) => Array.from({ length: 13 }, (_, n) => n)
        .every((n) => qEgal(lireFormule(latex, { n: Q(n) }), prix(s, n)));
    situations.forEach((s) => {
        if (!colle(s.latex, s)) throw new Error(`gen_175 : cible ${s.latex} fausse`);
    });
    const croisee = situations.some((s) => situations.some((u) => u !== s && colle(u.latex, s)))
        || leurres.some((l) => situations.some((s) => colle(l.latex, s)));
    if (croisee) return null;
    if (!deuxADeuxDifferentes([...situations, ...leurres].map((o) => o.latex), 'n')) return null;
    return { situations, leurres };
};

const assemblerRelier = (a, b, lieux, compo) => {
    const pairs = compo.situations.map((s) => ({ source: s.source, target: tex(s.latex) }));
    const cibles = compo.leurres.map((l) => ({ target: tex(l.latex), code: l.code }));
    const payload = makeRelier(shuffle(pairs), CONSIGNE_RELIER, { ...opts(L_TARIF), cibles_leurres: cibles });
    payload._meta.params = {
        a, b, lieux,
        distracteurs: Object.fromEntries(cibles.map((l) => [l.target, l.code])),
    };
    return payload;
};

const genFormuleRelier = () => {
    for (let essai = 0; essai < 60; essai++) {
        const a = randInt(3, 15);
        const b = randInt(3, 15);
        if (a === b) continue;                          // a = b : deux situations identiques
        const lieux = randomChoiceMultiple(LIEUX_RELIER, 3);
        const compo = composerRelier(a, b, lieux, randInt(0, 1) === 1);
        if (compo) return assemblerRelier(a, b, lieux, compo);
    }
    // Repli déterministe vérifié : a = 5, b = 12 ; cibles 5n, 12 + 5n, 5 + 12n ;
    // leurres (12 + 5) × n et 5 + 12 + n.
    const lieux = ['la piscine', 'le cinéma', 'la patinoire'];
    const compo = composerRelier(5, 12, lieux, true);
    if (!compo) throw new Error('gen_175 : repli relier');
    return assemblerRelier(5, 12, lieux, compo);
};

// ═════════ Carte 2 — Exprimer l'aire restante (l'exemple de réussite) ═════════

/** Rectangle L × l en cm, L de 10 à 30, l de L/2 à L − 1 ; (20 ; 13), l'exemple d'Eduscol, sacrifié. */
export const SACRIFIE_AIRE = { L: 20, l: 13 };
const tirerRectangle = () => {
    for (let essai = 0; essai < 60; essai++) {
        const L = randInt(10, 30);
        const l = randInt(Math.ceil(L / 2), L - 1);
        if (L === SACRIFIE_AIRE.L && l === SACRIFIE_AIRE.l) continue;
        return { L, l };
    }
    return { L: 24, l: 15 };
};

/**
 * La figure du plafond : le rectangle aux proportions L × l, les quatre carrés
 * gris aux coins, la figure restante en blanc ; ni cote ni lettre (le texte
 * donne les dimensions, la lettre x est dans l'énoncé).
 */
const svgAire = (L, l) => {
    const W = 220;
    const H = Math.round((W * l) / L);                 // de 110 à 209 : l ≥ L/2
    const c = Math.round(H * 0.24);                    // côté dessiné d'un carré
    const m = 10;
    const x0 = m; const y0 = m;
    const x1 = x0 + W; const y1 = y0 + H;
    const reste = [
        [x0 + c, y0], [x1 - c, y0], [x1 - c, y0 + c], [x1, y0 + c], [x1, y1 - c], [x1 - c, y1 - c],
        [x1 - c, y1], [x0 + c, y1], [x0 + c, y1 - c], [x0, y1 - c], [x0, y0 + c], [x0 + c, y0 + c],
    ].map((p) => p.join(',')).join(' ');
    const carres = [[x0, y0], [x1 - c, y0], [x0, y1 - c], [x1 - c, y1 - c]]
        .map(([x, y]) => `<rect x="${x}" y="${y}" width="${c}" height="${c}" fill="#cbd5e1" stroke="#64748b" stroke-width="1"/>`)
        .join('');
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W + 2 * m} ${H + 2 * m}" width="${W + 2 * m}" height="${H + 2 * m}">`
        + carres
        + `<polygon points="${reste}" fill="#ffffff" stroke="#1E3A8A" stroke-width="2" stroke-linejoin="round"/>`
        + '</svg>';
    return {
        version: 1,
        elements: [{
            type: 'image',
            config: {
                imageUrl: `data:image/svg+xml,${encodeURIComponent(svg)}`,
                maxWidth: 'small',
                alt: 'Un rectangle dont on a enlevé, à chacun des quatre coins, un carré gris ; les quatre carrés ont la même taille ; la figure restante est en blanc.',
            },
        }],
    };
};

const introAire = (L, l) => `<p>On enlève quatre carrés superposables aux quatre coins d’un rectangle de ${L} cm de longueur et ${l} cm de largeur.</p>`
    + '<p>On s’intéresse à l’aire de la figure restante, en blanc.</p>'
    + `<p>On note ${tex('x')} le côté d’un carré, en cm.</p>`;

/** L'aire restante calculée PAR MORCEAUX (second chemin) : la bande du milieu, puis les deux bandes entre les carrés. */
const aireParMorceaux = (L, l, x) => qAdd(qMul(qSub(Q(L), qMul(Q(2), x)), Q(l)), qMul(qMul(Q(2), x), qSub(Q(l), qMul(Q(2), x))));

const controlerCleAire = (latex, L, l) => {
    [1, 2, 3, 4].forEach((k) => {
        if (!qEgal(lireFormule(latex, { x: Q(k) }), aireParMorceaux(L, l, Q(k)))) {
            throw new Error(`gen_175 : clé ${latex} fausse pour ${L} × ${l}, x = ${k}`);
        }
    });
};

// ─── QCM : quelle formule donne l'aire restante ? ─────────────
// Les trois familles décidées, plus les_deux (L·l − x : un seul carré ET son
// aire prise pour son côté), qui complète la grille { 4 carrés, 1 carré } ×
// { x², x } : avec les quatre options décidées seules, la clé était l'option la
// plus proche des trois autres dans 100 % des tirages (205 rectangles sur 205),
// avec la grille complète dans 0 %. Cinq choix (mode auto, À ARBITRER).
const genAireQcm = () => {
    const { L, l } = tirerRectangle();
    const A = L * l;
    const options = [
        { latex: `${A} - 4x^2`, code: null },
        { latex: `${A} - 4x`, code: 'carre_oublie' },
        { latex: `${A} - x^2`, code: 'un_seul_carre' },
        { latex: `${A} - x`, code: 'les_deux' },
        { latex: `(${L} - 2x)(${l} - 2x)`, code: 'rectangle_interieur' },
    ];
    controlerCleAire(options[0].latex, L, l);
    if (!deuxADeuxDifferentes(options.map((o) => o.latex), 'x')) {
        throw new Error(`gen_175 : deux formules d'aire égales pour ${L} × ${l}`);
    }
    const choix = options.map((o) => tex(o.latex));
    const payload = makeQcm(choix, choix[0],
        `${introAire(L, l)}<p><b>Quelle formule donne l’aire de la figure restante, en cm² ?</b></p>`,
        { ...opts(L_AIRE), elements_additionnels: svgAire(L, l) });
    payload._meta.params = { L, l, distracteurs: options.slice(1).map((o) => o.code) };
    return payload;
};

// ─── Saisie : exprime l'aire restante ─────────────────────────
/**
 * Les écritures admises de L·l − 4x² (liste finie, comparaison d'expression) :
 * celles d'ecrituresPolynome (les deux ordres, le + de tête, 4*x²), puis, mode
 * auto, À ARBITRER, l'aire du rectangle laissée en produit (20*13 ou 13*20) et
 * le carré écrit 4*x*x. Le juge retire les espaces et confond × et *, ² et ^2.
 * La première est la canonique, celle du corrigé.
 */
export const ecrituresAire = (L, l) => {
    const base = ecrituresPolynome([{ coef: L * l, deg: 0 }, { coef: -4, deg: 2 }], 'x');
    const autres = [];
    [String(L * l), `${L}*${l}`, `${l}*${L}`].forEach((c) => {
        ['4x²', '4*x²', '4*x*x'].forEach((q) => autres.push(`${c} - ${q}`, `-${q} + ${c}`));
    });
    return [...base, ...autres.filter((e, i) => !base.includes(e) && autres.indexOf(e) === i)];
};

const genAireSaisie = () => {
    const { L, l } = tirerRectangle();
    const ecritures = ecrituresAire(L, l);
    controlerCleAire(`${L * l} - 4x^2`, L, l);
    if (ecritures[0] !== `${L * l} - 4x²`) throw new Error(`gen_175 : écriture canonique ${ecritures[0]}`);
    const payload = makeSaisie(ecritures[0],
        `${introAire(L, l)}<p><b>Exprime l’aire de la figure restante en fonction de ${tex('x')}.</b></p>`,
        {
            ...opts(L_AIRE), suffixe: 'cm²', strict: true, comparaison: 'expression', reponses_acceptees: ecritures,
            elements_additionnels: svgAire(L, l),
        });
    payload._meta.params = { L, l, ecritures_admises: ecritures.length };
    return payload;
};

// ═════════ Contrat des distracteurs (données pures, jamais lues à l'exécution) ═════════

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: [
        'chaque distracteur est une erreur NOMMÉE (codes dans _meta.params.distracteurs), jamais une option inventée',
        'toute formule affichée est relue dans son écriture LaTeX (rationnels exacts) : la clé redonne le prix de l\'histoire ou l\'aire calculée par morceaux (throw sinon), deux formules égales en tant que fonctions donnent un nouveau tirage ou un throw',
        'options, cibles et leurres tous écrits par tex() : une seule écriture en KaTeX se trahirait par la police',
    ],
    formule_abo_qcm: {
        support: 'tarif de tirerTarif (fonctions.js, partagé avec 176) : v de 1,5 à 3 €, w = v + 1 à 2 €, F = (w − v) × n0 avec n0 de 8 à 20, soit F de 8 à 40 € ; décimaux exacts en dixièmes',
        grille: 'prix par entrée (v ou w) × parenthèses (part fixe payée une fois ou à chaque entrée) : quatre cases, aucune option plus proche des autres que les autres',
        familles: {
            mauvais_prix: 'F + w × n : le prix de l\'entrée SANS abonnement pris pour le prix par entrée avec abonnement',
            parenthesage: '(F + v) × n : la part fixe payée à chaque entrée',
            les_deux: '(F + w) × n : les deux erreurs',
        },
        supprimees: {
            roles_echanges: 'F × n + v : remplacée par la grille (avec elle, la clé était l\'option la plus proche des trois autres dans 50,4 % des tirages)',
            somme_pour_produit: 'F + v + n : même raison ; elle reste au relier',
            candidat_mort: 'v + F × n : jamais servi (slice), et de même valeur que F × n + v',
        },
        garantie: 'v < w et F > 0 par construction : les quatre formules sont deux à deux différentes (contrôlé à chaque tirage)',
    },
    formule_relier: {
        support: 'a et b entiers de 3 à 15, différents ; trois lieux différents ; cibles a × n (« chaque entrée coûte a € »), b + a × n (« une carte à b €, puis a € l\'entrée »), a + b × n (« une carte à a €, puis b € l\'entrée »)',
        leurres: {
            parenthesage: '(a + b) × n : la carte payée à chaque entrée',
            somme_pour_produit: 'a + b + n : le prix par entrée ajouté au lieu d\'être multiplié (DEPP 2de q.4, 3,9 %)',
        },
        ecriture: 'chaque leurre est écrit dans l\'ordre des nombres d\'une des deux situations à carte, l\'autre leurre dans l\'ordre de l\'autre (tiré au hasard) : aucune des deux ne se relie en recopiant ses nombres dans l\'ordre',
        garantie: 'cinq formules deux à deux différentes, aucune cible ne redonne le prix d\'une autre situation, aucun leurre celui d\'une situation (relus), « Deux formules sont en trop. »',
    },
    aire_qcm_unique: {
        support: 'rectangle de L de 10 à 30 cm sur l de L/2 à L − 1 (entiers ; (20 ; 13) sacrifié), quatre carrés de côté x enlevés aux coins ; clé L·l − 4x² écrite avec la valeur de L·l ; cinq choix',
        familles: {
            carre_oublie: 'L·l − 4x : l\'aire d\'un carré prise pour son côté',
            un_seul_carre: 'L·l − x² : un seul carré enlevé',
            les_deux: 'L·l − x : un seul carré, et son aire prise pour son côté ; complète la grille (sans elle, la clé était l\'option la plus proche des autres dans 100 % des tirages)',
            rectangle_interieur: '(L − 2x)(l − 2x) : la figure restante prise pour le rectangle du milieu',
        },
        garantie: 'cinq polynômes deux à deux différents (relus en x = 1, 2, 3), la clé égale à l\'aire par morceaux (x = 1 à 4)',
    },
};

// ═════════ Registre ═════════

const GENERATORS = {
    formule_abo_qcm: genFormuleAboQcm,
    formule_relier: genFormuleRelier,
    aire_qcm_unique: genAireQcm,
    aire_texte: genAireSaisie,
};

export const CATEGORIES = [
    {
        id: 'formule',
        label: L_TARIF,
        formatsList: [
            { key: 'formule_abo_qcm', label: 'QCM' },
            { key: 'formule_relier', label: 'Relier' },
        ],
    },
    {
        id: 'aire',
        label: L_AIRE,
        formatsList: [
            { key: 'aire_qcm_unique', label: 'QCM' },
            { key: 'aire_texte', label: 'Saisie' },
        ],
    },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
